module.exports = __webpack_public_path__ + "img/arrow_up.77013572.svg";